export function quoteEntryTarget(search = '') {
  // Keep ad-click parameters on the first rendered step until GTM's async
  // Conversion Linker has read them. Dropping the query during the root route
  // redirect can leave a stale _gcl_aw cookie even though the app saved the
  // new GCLID to localStorage and Sell.
  if (!search) return '/step/1';

  const source = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const linker = new URLSearchParams();
  for (const key of ['gclid', 'gbraid', 'wbraid', 'dclid', 'gclsrc', '_gl', 'step1_cta', 'brand']) {
    const value = source.get(key);
    if (value) linker.set(key, value);
  }
  const query = linker.toString();
  return query ? `/step/1?${query}` : '/step/1';
}
